import React from 'react';
import PropTypes from 'prop-types';
import { Container, Content } from './css';

const Tooltip = ({ message }) => (
  <Container>
    <Content className="tooltip-message">{message}</Content>
  </Container>
);

Tooltip.propTypes = {
  message: PropTypes.string,
};

export default Tooltip;
